export const API_URL =
"https://multishopaestheticbackend.kwintechnologykw21.com/api/";
// export const API_URL = "http://localhost:5050/api/";
// export const API_URL = "http://192.168.0.108:5050/api/";
